const title = "Terms of Service – Team Banner Sports";

export {title}